const getDayAbbreviation = (date: Date): string => {
  const dayAbbreviations = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return dayAbbreviations[date.getDay()];
};

const getDayName = (date: Date | null, lang: string): string => {
    const dayNames: Record<string, string[]> = {
        en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        ja: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
    };
    lang = dayNames[lang] ? lang : "en";
    return dayNames[lang][date.getDay()] ?? dayNames["en"][date.getDay()];
};

const getMonthName = (month: number, lang: string, short = false, abbreviation = false): string => {
  const monthNames: Record<string, string[]> = {
  en: abbreviation
    ? ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
  de: abbreviation
    ? ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
    : ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
  es: abbreviation
    ? ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    : ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
  fr: abbreviation
    ? ["janv", "févr", "mars", "avr", "mai", "juin", "juill", "août", "sept", "oct", "nov", "déc"]
    : ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
  ja:  ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
  pl: abbreviation
    ? ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"]
    : ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"],
  zh: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
  }

    lang = lang == "Language" ? "en" : lang;

  return short ? monthNames[lang][month].substr(0, 3) : monthNames[lang][month];
};

const getYearAbbreviation = (date: Date): string => {
  const fullYear = date.getFullYear();
  const yearAbbreviation = fullYear.toString().slice(-2);
  return yearAbbreviation;
};

const returnsFormattedDate = (date: Date, format: string, lang: string): string => {
    if (lang == "en") {
        const validDateFormatRegex = /^[dDmMyY\-./ ]*$/;
        if (!validDateFormatRegex.test(format)) {
            console.error("Invalid date format:", format);
            throw new Error("Invalid date format");
        }
    }
  const placeholders: Record<string, any> = {
    d: date.getDate(),
    dd: String(date.getDate()).padStart(2, "0"),
    ddd: getDayAbbreviation(date),
    dddd: getDayName(date, lang),
    M: String(date.getMonth() + 1),
    MM: String(date.getMonth() + 1).padStart(2, "0"),
    MMM: getMonthName(date.getMonth(), lang, false, true),
    MMMM: getMonthName(date.getMonth(), lang),
    mm: String(date.getMonth() + 1).padStart(2, "0"),
    mmm: getMonthName(date.getMonth(),lang , false, true),
    mmmm: getMonthName(date.getMonth(),lang),
    yy: getYearAbbreviation(date),
    yyyy: date.getFullYear()
  };

  const validPlaceholdersRegex = /\b(d|dd|ddd|dddd|M|MM|MMM|MMMM|mm|mmm|mmmm|yy|yyyy)\b/g;
  const dateFormatted = format.replace(validPlaceholdersRegex, match => placeholders[match]);

  return dateFormatted;  
}

export const formatISODateMMDDYYYY = (input: string, format: string, lang: string) => {
  const defaultFormat = 'dd/mm/yyyy';
  format = format || defaultFormat;

  const date = new Date(input);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date");
  }    
  
  try {
    return returnsFormattedDate(date, format, lang);
  }
  catch (error) {
    return returnsFormattedDate(date, defaultFormat, lang);
  }

};


  